import { render, staticRenderFns } from "./QueueCard.vue?vue&type=template&id=0c102e94&"
import script from "./QueueCard.vue?vue&type=script&lang=js&"
export * from "./QueueCard.vue?vue&type=script&lang=js&"
import style0 from "./QueueCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports